import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import {
    AtomsProvider,
    LocalizationContextProvider,
    PageName,
    pageNameAtom,
    sellerAtom,
    floatingChatDataAtom,
    upmarketDataAtom,
    type FloatingChatData,
    type UpmarketData,
} from '@fiverr-private/seller_pages_toolbox';
import { RolloutContextData, RolloutContextProvider } from '../contexts/RolloutContext';
import { Seller } from '../types';
import { CurrencyConfig } from '../types/localization-kimera';
import { queryClient as defaultQueryClient } from './queryClient';

export interface AppProvidersLayerProps {
    rollouts: RolloutContextData;
    currency: CurrencyConfig;
    seller: Seller;
    queryClient?: QueryClient;
    floatingChatData: FloatingChatData;
    upmarketData: UpmarketData;
}

export const AppProvidersLayer: React.FC<React.PropsWithChildren<AppProvidersLayerProps>> = ({
    rollouts = {},
    currency,
    queryClient = defaultQueryClient,
    seller,
    floatingChatData,
    upmarketData,
    children,
}) => (
    <AtomsProvider
        atoms={[
            [sellerAtom, seller],
            [pageNameAtom, 'business_seller_page' as PageName],
            [floatingChatDataAtom, floatingChatData],
            [upmarketDataAtom, upmarketData],
        ]}
    >
        <QueryClientProvider client={queryClient}>
            <RolloutContextProvider value={rollouts}>
                <LocalizationContextProvider currency={currency}>{children}</LocalizationContextProvider>
            </RolloutContextProvider>
        </QueryClientProvider>
    </AtomsProvider>
);
